<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>æ</u-icon>
      </div>
      <div>
        <div><span>Référentiel</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <div id="treeview">
        <v-progress-circular
          indeterminate
          color="valid"
          v-if="repositoryTree.length === 0"
        />

        <div v-else>
          <v-treeview
            :items="repositoryTree"
            :search="search"
            :open-all="true"
          >
            <template slot="label" slot-scope="{ item }">
              <div v-if="item.type === 'skill' || item.type === 'subSkill'">
                <div class="app__treeview__branch">
                  <v-badge left :color="getWeightColor(item.type)" v-if="hasQuestionnaireSelected">
                    <template v-slot:badge>
                      <v-tooltip top color="#f0f0f0">
                        <template slot="activator" slot-scope="{ on }">
                          <span v-on="on" class="question__badge__weight"
                          >{{ item.totalWeight }}</span>
                        </template>
                        <span>{{ $t('pages.repository.Detail.tooltip.skillWeight')}}</span>
                      </v-tooltip>
                    </template>
                    {{item.name}}
                  </v-badge>
                  <span v-else>{{item.name}}</span>
                  <v-tooltip top color="#f0f0f0">
                    <template slot="activator" slot-scope="{ on }">
                      <v-btn v-on="on" small fab
                             :color="getQuestionCountColor(item.questionCount)"
                             @click.stop="questionOpenModalList(item)"
                      >{{item.questionCount}}
                      </v-btn>
                    </template>
                    <span>{{ $t('pages.repository.Detail.tooltip.questionCount') }}</span>
                  </v-tooltip>
                </div>

                <ul v-if="hasQuestionnaireSelected">
                  <li v-for="question in item.questions" :key="question.id">
                  <span :title="$t('pages.repository.Detail.tooltip.questionWeight')"
                        class="question-weight">
                    {{ question.weight }} -&nbsp;
                  </span>
                    {{ question.label }}
                  </li>
                </ul>
              </div>
              <span v-else>{{item.name}}</span>
            </template>
          </v-treeview>

          <!-- Modal qui affiche les questions associées-->
          <v-dialog
            v-model="modalQuestionList"
            content-class="v-dialog__ernest"
          >
            <div class="card__container__skill">
              <header>
                <v-btn small absolute right text tile color="error"
                       @click.stop="modalQuestionList=false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <h1>Question(s) associée(s)</h1>
              </header>

              <div class="card__content__treeview">
                <v-data-table :headers="headersQuestionRelated"
                              :items="selectedQuestions"
                              :loading="loadingQuestionList"
                              hide-default-footer
                >
                  <template v-slot:progress>
                    <v-progress-linear height="2" slot="progress" color="blue" indeterminate/>
                  </template>
                  <template v-slot:no-data>
                    Pas de question associée
                  </template>
                  <template v-slot:body="{items}">
                    <tbody>
                    <tr v-for="question in items" :key="question.id">
                      <td>{{ question.label }}</td>
                      <td>
                        <v-text-field v-model="question.weight"
                                      type="number"
                                      min="1" max="5"
                                      :error-messages="weightError(question.weight)"
                        />
                      </td>
                      <td>
                        <v-btn small
                               color="error"
                               fab
                               @click.stop="deleteQuestion(question.id)"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </div>
              <footer>
                <v-btn color="other1" @click.stop="questionOpenModalLikert">
                  Ajouter une question
                </v-btn>
                <v-btn color="valid" @click.stop="onSaveQuestionList" :disabled="saveDisabled">Sauvegarder</v-btn>
                <v-btn color="cancel" @click.stop="modalQuestionList=false">Annuler</v-btn>
              </footer>
            </div>
          </v-dialog>

          <!-- Modal qui affiche le tableau des questions de Likert-->
          <v-dialog
            v-model="modalQuestionLikert"
            content-class="v-dialog__ernest"
          >
            <div class="card__container__skill">
              <header>
                <v-btn small absolute right text tile color="error"
                       @click.stop="modalQuestionLikert=false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <h1>Questions de Likert</h1>
              </header>
              <div class="card__content__treeview">
                <v-data-table :headers="headersQuestionLikert"
                              :items="questions"
                              :loading="loadingQuestionLikert"
                >
                  <v-progress-linear height="2" slot="progress" color="blue" indeterminate/>
                  <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="question in items" :key="question.id">
                      <td>
                        <v-checkbox v-model="question.selected"/>
                      </td>
                      <td>{{ question.label }}</td>
                      <td>{{ question.text }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </div>
              <footer>
                <v-btn color="valid" @click.stop="onSaveQuestionLikert">Sauvegarder</v-btn>
                <v-btn color="cancel" @click.stop="modalQuestionLikert=false">Annuler</v-btn>
              </footer>
            </div>
          </v-dialog>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { DEFAULT_WEIGHT } from '@/store/questions'
import i18n from '@/plugins/i18n'

const badgeColors = {
  'skill': 'hsl(174, 80%, 30%)',
  'subSkill': 'hsl(174, 75%, 40%)'
}

export default {
  name: 'RepositoryDetail',
  data () {
    return {
      search: '',
      repositoryTree: [],
      selectedSkill: {},
      selectedQuestions: [],
      questions: [],
      openAll: true,
      loadingQuestionLikert: true,
      loadingQuestionList: true,
      modalQuestionLikert: false,
      modalQuestionList: false,
      headersQuestionRelated: [
        {
          text: 'Label',
          align: 'left',
          value: 'label'
        },
        {
          text: 'Pondération',
          align: 'center',
          value: 'weight'
        },
        {
          text: '',
          align: 'center',
          value: 'actions'
        }
      ],
      headersQuestionLikert: [
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'actions'
        },
        {
          text: 'Label',
          align: 'left',
          value: 'label'
        },
        {
          text: 'Texte',
          align: 'left',
          value: 'text'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('Repositories', [
      'hasRepositorySelected',
      'hasRepositoryInStorage',
      'questionnaireFilterId',
      'repositorySelected',
      'skill'
    ]),
    ...mapGetters('Questions', [
      'questionsLikert'
    ]),
    ...mapGetters('Questionnaires', [
      'questionnaires'
    ]),
    repositoryName () {
      return this.repositorySelected ? this.repositorySelected.name : ''
    },
    hasQuestionnaireSelected () {
      return !!this.questionnaireFilterId
    },
    saveDisabled () {
      return this.selectedQuestions.some(question => {
        this.isNoWeight(question.weight)
      })
    }
  },
  watch: {
    async questionnaireFilterId (newQuestionnaireId) {
      await this.loadRepository(newQuestionnaireId)
      this.repositoryTree = [this.repositorySelected]
    }
  },
  async created () {
    await this.loadRepository(this.hasQuestionnaireSelected ? this.questionnaireFilterId : false)
    this.repositoryTree = [this.repositorySelected]

    await this.loadQuestionnaires()
  },
  methods: {
    ...mapActions('Repositories', [
      'loadRepository',
      'loadFilteredRepository',
      'loadSkill',
      'saveSkill'
    ]),
    ...mapActions('Questions', [
      'loadQuestionsWithFilter',
      'loadQuestionsOfQuestionnaire'
    ]),
    ...mapActions('Questionnaires', [
      'loadQuestionnaires'
    ]),
    deleteQuestion (id) {
      this.selectedQuestions = this.selectedQuestions.filter(question => question.id !== id)
    },
    async questionOpenModalList (skill) {
      this.modalQuestionList = true
      this.selectedSkill = { ...skill }
      this.selectedQuestions = skill.questions.map(q => ({ ...q }))
      this.loadingQuestionList = false
    },
    async questionOpenModalLikert () {
      this.modalQuestionLikert = true
      if (this.hasQuestionnaireSelected) {
        await this.loadQuestionsOfQuestionnaire(this.questionnaireFilterId)
      } else {
        await this.loadQuestionsWithFilter('likert')
      }
      this.questions = this.questionsLikert
        .map(question => ({
          id: question.id,
          label: question.label,
          text: question.text,
          weight: question.skills
            .filter(skill => skill.id === this.selectedSkill.id)
            .reduce((weight, skill) => skill.weight, DEFAULT_WEIGHT),
          selected: this.selectedQuestions.map(q => q.id).includes(question.id)
        }))
      this.loadingQuestionLikert = false
    },
    onSaveQuestionLikert () {
      const preSelectedids = this.selectedQuestions.map(q => q.id)
      this.selectedQuestions = this.questions
        .filter(q => q.selected)
        .map(question => {
          return preSelectedids.includes(question.id)
            ? this.selectedQuestions.find(sq => sq.id === question.id)
            : { id: question.id, label: question.label, weight: question.weight }
        })
      this.modalQuestionLikert = false
    },
    async onSaveQuestionList () {
      await this.saveSkill({
        id: this.selectedSkill.id,
        newQuestions: this.selectedQuestions.map(q => ({ ...q, weight: parseInt(q.weight) }))
      })
      this.modalQuestionList = false
      this.repositoryTree = [this.repositorySelected]
    },
    getQuestionCountColor (questionCount) {
      const base = Math.max(1, this.repositorySelected.maxQuestionCount)
      const luminosity = Math.floor(95 - 40 * questionCount / base)
      return `hsl(183, 57%, ${luminosity}%)`
    },
    getWeightColor (itemType) {
      return badgeColors[itemType]
    },
    isNoWeight (weight) {
      const w = parseFloat(weight)
      return isNaN(w) || !Number.isInteger(w) || w > 5 || w < 1
    },
    weightError (weight) {
      return this.isNoWeight(weight) ? i18n.t('components.questions.weightError') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  @import "../../assets/style/styleAppDialogScopedErnest";

  #app__ernest {
    .v-treeview-node {
      margin-bottom: 10px;
    }
  }

  .v-badge {
    margin-left: 30px;
  }

  ul {
    list-style: none;
    margin-left: 50px;
    .question-weight{
      color: hsl(174, 80%, 30%);
    }
  }

  .app__treeview__branch {
    height: 65px;
    display: flex;
    align-items: center;

    .v-btn {
      margin-left: 20px;
    }

    .question__badge__weight {
      color: white;

    }
  }
</style>

<style lang="scss">
  @import "../../assets/style/styleAppDialogErnest";
</style>
